// extracted by mini-css-extract-plugin
export const lastCard = "tinyListCard-module--last-card--1JiHo";
export const cardWrapper = "tinyListCard-module--card-wrapper--3Fy4n";
export const listImage = "tinyListCard-module--list-image--1v-Kj";
export const listImageLink = "tinyListCard-module--list-image-link--2dpYl";
export const listImageOverlay = "tinyListCard-module--list-image-overlay--3iJhN";
export const listImageIcon = "tinyListCard-module--list-image-icon--1B931";
export const favIcon = "tinyListCard-module--fav-icon--1Z78G";